import { Action } from 'redux';
import { EMessageType } from './constants';
import { actionCreator } from '.';
import { IException } from '@/models';
import { v4 } from 'uuid';

const toMessageText = (value: unknown): string => {
	if (typeof value === 'string') {
		return value;
	}

	if (value instanceof Error) {
		return value.message || value.toString();
	}

	if (value === null || value === undefined) {
		return '';
	}

	if (typeof value === 'object') {
		try {
			return JSON.stringify(value, null, 2);
		} catch {
			return Object.prototype.toString.call(value);
		}
	}

	return String(value);
};

export const messageFactory = {
	apiErrorMessage(error: IException) {
		return actionCreator.CREATE_MESSAGE({
			id: v4(),
			message: toMessageText(error.message),
			title: 'Server Exception Occurred',
			type: EMessageType.ERROR,
			data: toMessageText(error.data)
		});
	},
	errorMessage(error: IException) {
		return actionCreator.CREATE_MESSAGE({
			id: v4(),
			message: toMessageText(error.message),
			title: 'Exception Occured',
			type: EMessageType.ERROR,
			data: toMessageText(error.data)
		});
	},
	message(
		type: EMessageType,
		title: string,
		message: string,
		largeText?: boolean
	) {
		return actionCreator.CREATE_MESSAGE({
			id: v4(),
			message,
			title,
			type,
			data: null,
			largeText: largeText
		});
	},
	dialog(
		title: string,
		message: string,
		okAction: Action,
		cancelAction: Action | null,
		allowCancel: boolean
	) {
		return actionCreator.CREATE_DIALOG({
			id: v4(),
			message,
			title,
			okAction,
			cancelAction,
			allowCancel
		});
	},
	progress(title: string) {
		return actionCreator.CREATE_PROGRESS({
			id: v4(),
			title,
			value: 0
		});
	},
	dismissProgress() {
		return actionCreator.DISMISS_PROGRESS();
	}
};
